import { Navigate } from "react-router";

import { useAppSelector } from "@/redux/store";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const order = useAppSelector((state) => state.order);

  if (!order.customerType) {
    return <Navigate to="/" />;
  }

  return children;
};

const EasiRechargeProtectedRoute = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const state = useAppSelector((prevState) => prevState.easiRecharge);

  if (!state.mobileNumber) {
    return <Navigate to="/" />;
  }

  return children;
};

export { ProtectedRoute, EasiRechargeProtectedRoute };
